import type { ToastKind } from "../../app/toolRegistry";

export type ToastMessage = {
  id: string;
  message: string;
  kind: ToastKind;
};

type ToastRegionProps = {
  messages: ToastMessage[];
};

export function ToastRegion({ messages }: ToastRegionProps) {
  return (
    <div className="toast-region" aria-live="polite" aria-label="Notifications">
      {messages.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.kind}`}>
          {toast.message}
        </div>
      ))}
    </div>
  );
}
